<script>
    import {replace} from "svelte-spa-router";
    import { onMount,beforeUpdate } from 'svelte';
    import {docs,logueo} from '../store';
    import Controlador from "../controlador.svelte";
    let categorias = [];
    let categoria = "";
    let categoriaSelect = "";
    let id = "config:categorias";
    let rev = "";
    let c;
    onMount(()=>{
        categorias = ($docs.find((el)=>el._id == "config:categorias")? $docs.find((el)=>el._id == "config:categorias").categorias : []);
        rev = ($docs.find((el)=>el._id == "config:categorias")? $docs.find((el)=>el._id == "config:categorias")._rev : "")
        if (!$logueo){
			replace('/');
		}
    })
    beforeUpdate(()=>{
        if (categorias){
            categorias = ($docs.find((el)=>el._id == "config:categorias")? $docs.find((el)=>el._id == "config:categorias").categorias : []);
            rev = ($docs.find((el)=>el._id == "config:categorias")? $docs.find((el)=>el._id == "config:categorias")._rev : "")
        }
    })
    function seleccionarCat(){
        categoria = categoriaSelect;
    }
    function agregarCat(){
        categorias.push(categoria);
        guardarCambios();
        deseleccionar();
    }
    function eliminarCat(){
        let id = categorias.find((el)=>el == categoriaSelect);
        categorias.slice(id-1,1);
        guardarCambios();
        deseleccionar();
    }
    function editarCat(){
        let id = categorias.find((el)=>el == categoriaSelect);
        categorias[id] = categoria;
        guardarCambios();
        deseleccionar();
    }
    function deseleccionar(){
        categoriaSelect = "";
        categoria = "";
    }
    function guardarCambios(){
        let doc = {categorias:categorias};
        if (rev != ""){
            doc._rev = rev;
            doc._id = id;
        }
        c.editarCategorias(doc);
        deseleccionar();
    }
</script>
<Controlador bind:this={c} />
<div class="w-full p-2 flex flex-col">
    <a href="#/deposito/-1" class="w-full rounded bg-red-500 text-white shadow mb-2 p-2">
		<i class="ri-arrow-left-line" />
		Volver
	</a>
    <select on:blur={seleccionarCat} bind:value={categoriaSelect} class="w-full p-2 mb-2 bg-white rounded shadow">
        <option selected={"" == categoriaSelect} value="">Categorias</option>
        {#each categorias as cat}
            <option selected={cat == categoriaSelect} value={cat}>{cat}</option>
        {/each}
    </select>
    <input type="text" placeholder="Categoria" bind:value={categoria} class="w-full p-2 bg-white rounded shadow" />
    <div class="w-full p-2 flex items-center justify-center">
        <button class="w-1/2 m-2 text-xs md:text-md text-white p-2 bg-red-500 cursor-pointer flex items-center justify-center rounded shadow" on:click={(categoriaSelect == ""?agregarCat:editarCat)}>{categoriaSelect?"Editar":"Agregar"}</button>
        <button class="w-1/2 m-2 text-xs md:text-md text-white p-2 bg-red-500 cursor-pointer flex items-center justify-center rounded shadow" on:click={(categoriaSelect == ""?eliminarCat:deseleccionar)}>{categoriaSelect?"Eliminar":"Limpiar"}</button>
    </div>
</div>
